import { z } from 'zod/v4'

import type { BotCategory, BotConfidence, BotDetectionSource, BotIdentity } from './models'

export const botDetectionCategorySearchParamSchema = z.enum([
  'advertising_and_marketing',
  'aggregator',
  'ai_agent',
  'ai_assistant',
  'ai_browser',
  'ai_crawler',
  'ai_search',
  'browser_automation',
  'ecommerce',
  'monitoring_and_analytics',
  'other',
  'scraping',
  'security',
  'search_engine_crawler',
  'search_engine_optimization',
  'unknown',
] as const satisfies readonly BotCategory[])

export const botDetectionIdentitySearchParamSchema = z.enum([
  'verified',
  'signed',
  'spoofed',
  'unknown',
] as const satisfies readonly BotIdentity[])

export const botDetectionConfidenceSearchParamSchema = z.enum([
  'high',
  'medium',
  'low',
] as const satisfies readonly BotConfidence[])

export const botDetectionSourceSearchParamSchema = z.enum([
  'identification',
  'edge',
] as const satisfies readonly BotDetectionSource[])

export const botDetectionArraySearchParam = <TSchema extends z.ZodType>(schema: TSchema) =>
  z
    .union([schema, z.array(schema)])
    .optional()
    .transform((value) => {
      if (!value) {
        return undefined
      }
      return Array.isArray(value) ? value : [value]
    })

export const botDetectionBooleanSearchParam = z
  .union([z.boolean(), z.enum(['true', 'false'])])
  .optional()
  .transform((value) => {
    if (value === undefined) {
      return undefined
    }
    return value === true || value === 'true'
  })
